import { ActionType, PayloadType, changeThemeSuccess, requestThemeSuccess } from '../actions/themeActions';
import { CHANGE_THEME, CHANGE_THEME_FAILED, REQUEST_THEME, REQUEST_THEME_FAILED } from '../constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import config from '../../shared/config';

import safeAxios from '../../shared/api/safeFetch';

const { apiUrl } = config;

function* requestThemeHandler(action: ActionType<string>) {
  try {
    const { data } = yield call(safeAxios, `${apiUrl}/user_prefs/${action.payload}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    yield put(requestThemeSuccess(data));
  } catch (error) {
    yield put({
      message: (error as Error).message,
      type: REQUEST_THEME_FAILED,
    });
  }
}
function* changeThemeHandler(action: ActionType<PayloadType>) {
  const {
    payload: { id, query },
  } = action;
  try {
    yield call(safeAxios, `${apiUrl}/user_prefs/${id}`, {
      body: query,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
    });
    yield put(changeThemeSuccess(query));
  } catch (error) {
    yield put({
      message: (error as Error).message,
      type: CHANGE_THEME_FAILED,
    });
  }
}

export default function* fetchUserWatcher(): Generator {
  yield takeEvery(REQUEST_THEME, requestThemeHandler);
  yield takeEvery(CHANGE_THEME, changeThemeHandler);
}
